import { Controller } from 'stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['plan', 'planNameInput', 'planChargeBtn', 'payForm']

  connect() {
    //switch from monthly to annual pricing tables
    this.bouncy_filter($(this.element));

    this.planTargets.forEach((el) => {
      el.addEventListener('click', (event) => {
        this.setPaymentPlan(event.currentTarget)
      })
    })
  }

  bouncy_filter(container) {
    var pricing_table = container;

    var filter_list_container = pricing_table.find('.pricing-switcher'),
      filter_radios = filter_list_container.find('input[type="radio"]'),
      pricing_table_wrapper = pricing_table.find('.pricing-wrapper');

    //store pricing table items
    var table_elements = {};
    filter_radios.each(function(){
      var filter_type = $(this).val();
      table_elements[filter_type] = pricing_table_wrapper.find('li[data-type="' + filter_type + '"]');
    });

    //detect input change event
    filter_radios.on('change', (event) => {
      event.preventDefault();
      //detect which radio input item was checked
      var selected_filter = $(event.target).val();

      //give higher z-index to the pricing table items selected by the radio input
      this.show_selected_items(table_elements[selected_filter]);

      //rotate each pricing-wrapper
      //at the end of the animation hide the not-selected pricing tables and rotate back the .pricing-wrapper

      // if( !Modernizr.cssanimations ) {
      //   this.hide_not_selected_items(table_elements, selected_filter);
      //   pricing_table_wrapper.removeClass('is-switched');
      // } else {
      pricing_table_wrapper.addClass('is-switched').eq(0).one('webkitAnimationEnd oanimationend msAnimationEnd animationend', () => {
        this.hide_not_selected_items(table_elements, selected_filter);
        pricing_table_wrapper.removeClass('is-switched');
        //change rotation direction if .pricing-list has the .bounce-invert class
        if(pricing_table.find('.pricing-list').hasClass('bounce-invert')) pricing_table_wrapper.toggleClass('reverse-animation');
      });
      // }
    });
  }

  show_selected_items(selected_elements) {
    selected_elements.addClass('is-selected');
  }

  hide_not_selected_items(table_containers, filter) {
    $.each(table_containers, function(key, value){
      if ( key != filter ) {
        $(this).removeClass('is-visible is-selected').addClass('is-hidden');
      } else {
        $(this).addClass('is-visible').removeClass('is-hidden is-selected');
      }
    });
  }

  setPaymentPlan(selectBtn) {
    this.planNameInputTarget.value = selectBtn.dataset.planName
    this.planChargeBtnTarget.value = `Pay $${selectBtn.dataset.charge}`
  };
}
